export const lang = {
  copySuccess: '共有リンクはすでにクリップボードにコピーされている',
  copyFail: '共有リンクの複製に失敗する',
  invalidFile: 'ファイルがサポート',
  invalidType: '導入したデータのフォームはサポートできません',
  invalidSize: 'データは30メガを超えています',
  inputFileType: 'サポートされているフォーマット :jpg，png，pdf，psd，ai',
  inputFileSize: 'サイズ制限:30MB',
  inputFileLimit:
    'データ要求:AIデータは必ず全てリンクで使った画像と字体などを嵌め込めます。',
  cameraTitle: 'カメラ',
  cameraSubTitle: 'アプリを使って写真を撮ってデザインする',
  selectFile: '選択ファイル',
  labelPixel: 'ピクセル',
  labelWidth: '幅',
  labelHeight: '高さ',
  labelRatio: '解像度',
  labelSun: '日傘',
  labelRain: '雨傘',
  titleRotate: 'デザインイメージの回転',
  titleZoom: 'デザインイメージの拡大縮小',
  titleCamera: '本体カメラでの撮影（デザイン摘要）',
  titleGallery: '本体カメラロール内の写真選択',
  titlePatterns: 'アプリ内の既存デザイン',
  titleHelp: 'ヘルプボタンアイコン説明',
  titleBack: '戻る',
  titleAddLogo: 'ロゴを加える',
  titleAddText: '文字の入力',
  titleUmbOpen: '伞を开',
  titleUmbFold: '伞閉じ',
  titleUmbSleeve: '伞を戸',
  titleUmbHandle: '伞の头',
  titleDesignSleeve: '傘のカバーをデザインする',
  titleAddToCart: 'カゴ入れ',
  titleShare: 'デザインシェア',
  title3D: '手元を選ぶ',
  titleCart: 'カゴカート',
  titleHome: 'トップページ',
  titleProductUmb: '伞',
  titleProductScarf: 'スカーフ',
  titleProductGift: 'プレゼント',
  titleProductBag: 'バックパック',
  cameraPermission: 'システムの設定でカメラの権限を開けてください',
  libraryPermission: 'システムの設定でアルバムの権限を開けてください',
  placeholderText: 'ここに入力してください',
  titleGetCode: '検証コード',
  titleGuest: '観光客',
  titlePhone: '携帯電話の番号を入力する',
  titleCode: '入力検証コード',
  titleLogin: 'ログイン',
  titleOtherLogin: '他の登録方式',
  titleDeal: '登録することは同意を示す',
  titleUserAgreement: 'ユーザープロトコル',
  titlePrivacyPolicy: 'プライバシー条項',
  titleErrorPhone: '携帯電話の番号が合わない',
  titleErrorCode: '検証コードエラー',
  labelDownloadApp: 'ここをタップしてアプリをインストールします',
  labelStartDesign: 'ここをクリックしてデザインを始めます',
  labelAccountLogin: 'ログイン',
  labelQuickLogin: 'クイックログイン',
  labelForget: 'パスワードを忘れる',
  labelRegister: 'アカウントを登録する',
  labelConfirm: '确认',
  labelRetrieve: 'パスワードを取り戻す',
  labelHasAccount: '既存のアカウント',
  labelPassword: '暗証番号を入力する',
  labelNewPassword: '新しいパスワードを入力する',
  labelNoRegister: 'アカウントなし',
  labelSaveSuccess: '保存に成功する',
  labelSaveFail: '保存に失敗',
  alreadySave: '保存済み',
  confirmSleeve: '傘袋確認',
  reDesignSleeve: '自分でデザインする',
  defaultDesignSleeve: '<p style="margin: 0;">このままのデザイ<br>ンで決定する</p>',
  defaultText: '文字を編集する',
  clear: '全て削除',
  warningClear: '注意：全て削除したアイテムは元に戻せません！',
  confirmClear: '全て削除しても良いですか？',
  cancel: 'キャンセル',
  remove: '削除されますがよろしいでしょうか？',
  warningRemove: '削除したアイテムは元に戻せません！',
  confirmRemove: '削除',
  product_umb: '伞',
  product_scarf: 'スカーフ',
  product_mask: 'マスク',
  save: '保存に',
  orderIdTitle: '注文番号',
  buy: '購入へ進む',
  inputImageFail: '画像のインポートに失敗しました'
}
